import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import {BaseError} from "../../base-error";
import {ServiceCopyControllerService} from "../../../../services/service-controller/service-copy-controller.service";
import {ClassificationControllerService} from "../../../../services/classifications-controller/classification-controller.service";

@Component({
  selector: "service-import-modal",
  templateUrl: "./service-import-modal.component.html",
})
export class ServiceImportModalComponent extends BaseError implements OnChanges {
  @Output() public formSubmit = new EventEmitter();
  @Input()public serviceName: string;
  @Input()public serviceId: string;
  @Input() public catalogsDataString: string;
  public catalogsData: any;

  constructor(private classificationControllerService: ClassificationControllerService,
              private serviceCopyControllerService: ServiceCopyControllerService,
              toastr: ToastrService) {
    super(toastr);
  }

  public ngOnInit() {
    this.readCatalogs(this.catalogsDataString);
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.catalogsDataString.currentValue) {
      this.readCatalogs(this.catalogsDataString);
    }
  }

  public readCatalogs(data: string) {
    if (data) {
      this.catalogsData = data;
    }
  }

  public cancel() {
    this.formSubmit.emit({
      save: false, cancel: true,
    });
  }
  public getHeaderSizeClass(type) {
    if ( type === "title" ) {
      return "col-11";
    } else {
      return "col-1";
    }
  }

  public copy() {
    this.formSubmit.emit({
      save: true, catalogsData: this.catalogsData,
    });
  }
}
